exports.colors = {
  primary: "#fb923c",
  secondary: "#fdba74",
  danger: "#ef4444",
  warning: "#fcd34d",
  success: "#22c55e",
  info: "#bae6fd",
};
